/**
 * Handle decimal point values based on the currency object
 * Truncates to the nearest decimal place provided using JS toFixed() method
 * formatCurrencyWithDecimal(1245.8788,2) => 1245.89
 * formatCurrencyWithDecimal(1245.8788,3) => 1245.879
 * formatAsCurrencyWithDecimal(400,0) => 400
 * decimal value => add that or truncate to the decimal value provided
 * *
*/

export const formatCurrencyWithDecimal = (amount, decimalPoint: number) => {
    return Number.parseFloat(amount)
        .toLocaleString('en-US', {
            minimumFractionDigits: decimalPoint,
            maximumFractionDigits: decimalPoint
        });
};